import { OfferFragment } from '@occc/graphql';
import { OfferType } from '@occc-app/offerValidationService/types';
import { isSupportedEarningMechanism } from '@occc-app/routes/CampaignComponents/components/TriggerOnProgress/utils';

export type ScheduleBlockId =
  | 'Dates'
  | 'TriggerOnVisibility'
  | 'TriggerOnFulfillment'
  | 'TriggerOnProgress';

export type ScheduleBlocksVisibility = Partial<Record<ScheduleBlockId, boolean>>;

export const getScheduleVisibility = (
  offer?: Pick<OfferFragment, 'earningMechanism'> | null,
  type?: OfferType | null,
): ScheduleBlocksVisibility => {
  if (type === OfferType.StoredValue) {
    return {
      Dates: true,
      TriggerOnVisibility: false,
      TriggerOnFulfillment: false,
      TriggerOnProgress: false,
    };
  }

  if (type === OfferType.Award) {
    return {
      Dates: true,
      TriggerOnVisibility: true,
      TriggerOnFulfillment: true,
      TriggerOnProgress: false,
    };
  }

  return {
    Dates: true,
    TriggerOnVisibility: true,
    TriggerOnFulfillment: type !== OfferType.Billboard,
    TriggerOnProgress: offer?.earningMechanism
      ? isSupportedEarningMechanism(offer.earningMechanism.__typename)
      : false,
  };
};
